import { useIntl } from "react-intl";

import {
    ProductNavBar,
    ProductNavDropdown,
    ProductNavLink
} from "@/components/wpl/product-navbar/src";
import { useLocalizedHref } from "@/libraries/web-framework";

export interface SoftwareDevelopmentProductNavProps {
    selectedNavLink?: "continuousDelivery" | "git" | "agile" | "microservices";
}

export const SoftwareDevelopmentProductNav = ({
    selectedNavLink
}: SoftwareDevelopmentProductNavProps) => {
    const intl = useIntl();
    const devopsDropdown = [
        {
            header: "",
            hideHeader: true,
            items: [
                {
                    label: intl.formatMessage({
                        id: "SoftwareDevelopment.navbar.dropdown.link.delivery",
                        defaultMessage: "Continuous Delivery"
                    }),
                    href: useLocalizedHref("/continuous-delivery"),
                    isSelected: selectedNavLink === "continuousDelivery"
                },
                {
                    label: intl.formatMessage({
                        id: "SoftwareDevelopment.navbar.dropdown.link.git",
                        defaultMessage: "Git"
                    }),
                    href: useLocalizedHref("/git"),
                    isSelected: selectedNavLink === "git"
                }
            ]
        }
    ];

    return (
        <ProductNavBar
            productHref={useLocalizedHref("/software-development")}
            productName="softwaredevelopment"
            ariaLabel={intl.formatMessage({
                id: "SoftwareDevelopmentProductNav.logo-label",
                defaultMessage: "Software Development"
            })}
            showTextWithoutLogo={true}
            showFreeHrefButton={false}
            dataProductKey="softwareDevelopment"
            logoLinkWrapperWidth="max-content"
        >
            <ProductNavDropdown
                label={intl.formatMessage({
                    id: "SoftwareDevelopment.navbar.dropdown.devops",
                    defaultMessage: "DevOps"
                })}
                groups={devopsDropdown}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "SoftwareDevelopment.navbar.agile",
                    defaultMessage: "Agile"
                })}
                href={useLocalizedHref("/agile")}
                isSelected={selectedNavLink === "agile"}
            />
            <ProductNavLink
                label={intl.formatMessage({
                    id: "SoftwareDevelopment.navbar.microservices",
                    defaultMessage: "Microservices"
                })}
                href={useLocalizedHref("/microservices")}
                isSelected={selectedNavLink === "microservices"}
            />
        </ProductNavBar>
    );
};

export default SoftwareDevelopmentProductNav;
